import { render, staticRenderFns } from "./NominateReplacementManagerDialog.vue?vue&type=template&id=20c64d83&scoped=true&"
import script from "./NominateReplacementManagerDialog.vue?vue&type=script&lang=ts&"
export * from "./NominateReplacementManagerDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c64d83",
  null
  
)

export default component.exports